<template>
  <div class="">
    <div class="w-full max-w-sm h-auto p-4 bg-white rounded-xl shadow-md flex flex-col justify-start items-start gap-4 overflow-hidden">
      <div class="w-full h-auto flex flex-col justify-start items-start gap-2">
      <div class="text-[#403b38] text-base font-bold font-['Outfit'] leading-normal tracking-wide">{{ title }}</div>

      <div class="text-[#403b38] text-sm font-normal font-['Outfit'] leading-tight">{{ description }}</div>
      <br>
      <ul class="w-full flex flex-wrap gap-2">
        <div class="flex-col justify-start items-start gap-2 flex">
        <!-- Loop through actions and open dialog on click -->
        <li 
          v-for="(item, index) in actions" 
          :key="index" 
          class="flex items-center text-pink-500 cursor-pointer" 
          @click="openDialog(index)"
        >
        <div class="px-4 py-2 bg-[#fbeae6] rounded-3xl justify-start items-center gap-2 inline-flex">
      <div class="text-[#ed6e4e] text-sm font-normal font-['Outfit'] leading-tight">{{ item.title }}</div>
    </div>
        
        </li></div>
      </ul></div></div>

    <!-- Expandable box content -->
    <div v-if="expandedIndex !== null" class="mt-4 p-4 bg-gray-800 rounded">
      <p class="text-gray-300">{{ actions[expandedIndex].content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    title: String,
    description: String,
    actions: Array, // Expecting each action item to have a `title` and `content`. Need to probably revisit this.
  },
  data() {
    return {
      expandedIndex: null, // Track which action is expanded
    };
  },
  methods: {
    toggleExpand(index) {
      // If the clicked item is already expanded, collapse it
      // Otherwise, set it as the expanded item
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
/* Optional styles for the expandable box */
</style>
